import { createFileRoute } from "@tanstack/react-router";

import { BivySticks } from "@/features/bivy-sticks/bivy-sticks";
import { BIVY_STICKS_QUERY } from "@/features/bivy-sticks/graphql/bivy-sticks-query";

export const Route = createFileRoute("/_authenticated/bivy-sticks")({
  component: BivySticks,
  loader: async ({ context }) => {
    if (context.urqlClient) {
      await context.urqlClient.query(BIVY_STICKS_QUERY, {}).toPromise();
    }
  },
});
